import { Routes, Route, Navigate } from 'react-router-dom';
import { WafConsole } from './WafConsole';

/**
 * WAF (Owl / Mlytics) module, per provisioned service.
 *
 *   /services/waf/:serviceId → console for that Owl/Mlytics service
 *   /services/waf            → back to the services dashboard (opened from a card)
 */
export function WafPage() {
  return (
    <Routes>
      <Route path=":serviceId/*" element={<WafConsole />} />
      <Route index element={<Navigate to="/services" replace />} />
    </Routes>
  );
}

export default WafPage;
